import React, { useState } from "react";
import HotelPrivacyPolicy from "./HotelPrivacyPolicy";
import PrivacyPolicy from "./PrivacyPolicy";

const PrivacyIndex = ({ location, host }) => {
  const [isHotelzify] = useState(
    [
      "https://hotelzify.com/privacy-policy",
      "https://www.hotelzify.com/privacy-policy",
      "https://www.dev.hotelzify.com/privacy-policy",
      "http://localhost:3005/privacy-policy",
      "https://dev.hotelzify.com/privacy-policy",
      "https://bookmystay.io/privacy-policy",
      "https://www.bookmystay.io/privacy-policy",
    ].includes(window.location.href)
  );

  return !isHotelzify ? <HotelPrivacyPolicy host={host} /> : <PrivacyPolicy />;
};

export default PrivacyIndex;
